/**
 * Custom logging utility that provides styled console output when debugging is enabled.
 * Supports regular logging, collapsible groups, and table formatting with color-coded status styles.
 * Only outputs logs when DEBUG flag is true.
 */
(function (g) {
  const DEBUG =
    true ||
    window.Shopify?.theme?.role === "development" ||
    window.Shopify?.theme?.role === "unpublished",
    styles = {
      success:
        "background:darkgreen;color:white;padding:2px 6px;border-radius:3px",
      error: "background:darkred;color:white;padding:2px 6px;border-radius:3px",
      warning:
        "background:darkorange;color:white;padding:2px 6px;border-radius:3px",
      info: "background:blue;color:white;padding:2px 6px;border-radius:3px",
      filename:
        "background:#333;color:#bada55;padding:2px 6px;border-radius:3px;margin-left:4px",
    };

  const getCallerFile = () => {
    try {
      return (
        (
          new Error().stack
            .split("\n")
            .find(
              (l) =>
                ((l.includes("/assets/") ||
                  l.includes("/sections/") ||
                  l.includes("/snippets/")) &&
                  !l.includes("/custom_sitewide.js")) ||
                !l.includes("jquery-"),
            ) || ""
        ).match(/\/(assets|sections|snippets)\/([^:?]+)\??/)?.[2] || ""
      );
    } catch (e) {
      return "";
    }
  };

  const log = (...args) => DEBUG && console.log(...args);

  const collapse = (type, data, title = "Log", status = "info") => {
    if (!DEBUG) return;
    const file = getCallerFile();
    console.groupCollapsed(
      `%c ${title}${file ? " %c" + file : ""}`,
      styles[status] || styles.info,
      file ? styles.filename : "",
    );
    type === "table" ? console.table(data) : console.log(data);
    console.groupEnd();
  };

  log.table = (data, title, status) => collapse("table", data, title, status);
  log.collapse = (data, title, status) => collapse("log", data, title, status);
  g.log = log;
})(typeof window !== "undefined" ? window : globalThis);

const log = window.log;

/**
 * Initializes and manages a Slick carousel with separate mobile and desktop configurations.
 * Ensures no unnecessary reinitialization during window resizing.
 *
 * @param {jQuery} carousel - The carousel element(s).
 * @param {Object} mobileOptions - Slick options for mobile view.
 * @param {number} breakpoint - The breakpoint to switch between mobile and desktop configurations.
 * @param {Object|null} desktopOptions - Slick options for desktop view. If null, unslick on desktop.
 */
function handleResponsiveCarousel(
  carousel,
  mobileOptions,
  breakpoint = 1024,
  desktopOptions = null,
) {
  let currentView = null; // Keeps track of the current view ('mobile' or 'desktop')

  function initializeCarousel() {
    const isDesktop = $(window).width() >= breakpoint;

    if (isDesktop) {
      if (currentView !== "desktop") {
        // Switch to desktop view
        if (carousel.hasClass("slick-slider")) carousel.slick("unslick"); // Destroy mobile Slick if initialized
        if (desktopOptions) carousel.slick(desktopOptions); // Initialize with desktop options
        currentView = "desktop";
      }
    } else {
      if (currentView !== "mobile") {
        // Switch to mobile view
        if (carousel.hasClass("slick-slider")) carousel.slick("unslick"); // Destroy desktop Slick if initialized
        carousel.slick(mobileOptions); // Initialize with mobile options
        currentView = "mobile";
      }
    }
  }

  initializeCarousel();
  $(window).on("resize", function () {
    initializeCarousel();
  });
}

// Function to copy text to clipboard
function copyToClipboard(text) {
  var $tempInput = $("<input>");
  $("body").append($tempInput);
  $tempInput.val(text).select();
  document.execCommand("copy");
  $tempInput.remove();
}

$(document).ready(function () {
  const useChevron = false;
  const icons = {
    arrow_left:
      "https://cdn.shopify.com/s/files/1/0623/4485/5760/files/Arrow_Left.svg?v=1744058170",
    arrow_right:
      "https://cdn.shopify.com/s/files/1/0623/4485/5760/files/Arrow_Right.svg?v=1744058170",
    chevron_left:
      "https://cdn.shopify.com/s/files/1/0623/4485/5760/files/chevron_left.svg?v=1745952252",
    chevron_right:
      "https://cdn.shopify.com/s/files/1/0623/4485/5760/files/chevron_right.svg?v=1745952252",
    chevron_left_svg: `<svg xmlns="http://www.w3.org/2000/svg" width="10" height="20" viewBox="0 0 10 20" fill="none" style="color: black;">
      <path d="M9.73127 17.7033C9.81711 17.7956 9.88422 17.9041 9.92876 18.0226C9.97331 18.1412 9.99441 18.2675 9.99088 18.3944C9.98735 18.5212 9.95924 18.6461 9.90816 18.7619C9.85709 18.8778 9.78405 18.9822 9.69321 19.0694C9.60237 19.1565 9.49551 19.2247 9.37873 19.2699C9.26196 19.3151 9.13755 19.3366 9.01262 19.333C8.88768 19.3294 8.76467 19.3009 8.6506 19.249C8.53653 19.1971 8.43363 19.123 8.34779 19.0307L0.260085 10.3358C0.093063 10.1565 8.23032e-07 9.91899 8.44612e-07 9.67214C8.66192e-07 9.42529 0.0930631 9.1878 0.260085 9.00842L8.34779 0.31256C8.43307 0.218306 8.53594 0.142195 8.65043 0.0886505C8.76492 0.0351036 8.88875 0.00519067 9.01472 0.000647379C9.14069 -0.00389782 9.2663 0.0170201 9.38424 0.0621804C9.50219 0.107341 9.61012 0.175845 9.70177 0.263717C9.79342 0.351588 9.86696 0.457074 9.91811 0.574046C9.96927 0.691018 9.99703 0.817145 9.99977 0.945104C10.0025 1.07306 9.9802 1.2003 9.9341 1.31942C9.88801 1.43854 9.81906 1.54718 9.73127 1.63902L2.26013 9.67214L9.73127 17.7033Z" fill="currentColor"/>
    </svg>`,
    chevron_right_svg: `<svg xmlns="http://www.w3.org/2000/svg" width="10" height="20" viewBox="0 0 10 20" fill="none" style="color: black;">
      <path d="M0.268734 17.7033C0.182892 17.7956 0.115784 17.9041 0.0712384 18.0226C0.0266942 18.1412 0.00558558 18.2675 0.00911991 18.3944C0.0126533 18.5212 0.0407609 18.6461 0.0918359 18.7619C0.142911 18.8778 0.215954 18.9822 0.306794 19.0694C0.397634 19.1565 0.504494 19.2247 0.621269 19.2699C0.738045 19.3151 0.862451 19.3366 0.987384 19.333C1.11232 19.3294 1.23533 19.3009 1.3494 19.249C1.46347 19.1971 1.56637 19.123 1.65221 19.0307L9.73992 10.3358C9.90694 10.1565 10 9.91899 10 9.67214C10 9.42529 9.90694 9.1878 9.73991 9.00842L1.65221 0.31256C1.56693 0.218306 1.46406 0.142195 1.34957 0.0886505C1.23508 0.0351036 1.11125 0.00519067 0.985279 0.000647379C0.859307 -0.00389782 0.7337 0.0170201 0.615755 0.0621804C0.497812 0.107341 0.38988 0.175845 0.298231 0.263717C0.206583 0.351588 0.133044 0.457074 0.0818856 0.574046C0.0307277 0.691018 0.00297003 0.817145 0.000225367 0.945104C-0.0025193 1.07306 0.0198034 1.2003 0.0658973 1.31942C0.111992 1.43854 0.180939 1.54718 0.268732 1.63902L7.73987 9.67214L0.268734 17.7033Z" fill="currentColor"/>
    </svg>`,
  };
  const buttons = {
    prevArrow: `<button type='button' aria-label='Arrow Left' class='slick-prev pull-left'><img class='left_arrow' src='${useChevron ? icons.chevron_left : icons.arrow_left}' alt='arrow'/></button>`,
    nextArrow: `<button type='button' aria-label='Arrow Right' class='slick-next pull-right'><img class='right_arrow' src='${useChevron ? icons.chevron_right : icons.arrow_right}' alt='arrow'/></button>`,
    prevArrowChevronIMG: `<button type='button' aria-label='Arrow Left' class='slick-prev pull-left'><img class='left_arrow' src='${icons.chevron_left}' alt='arrow'/></button>`,
    nextArrowChevronIMG: `<button type='button' aria-label='Arrow Right' class='slick-next pull-right'><img class='right_arrow' src='${icons.chevron_right}' alt='arrow'/></button>`,
    prevArrowChevron: `<button type='button' aria-label='Arrow Left' class='slick-prev pull-left'>${icons.chevron_left_svg}</button>`,
    nextArrowChevron: `<button type='button' aria-label='Arrow Right' class='slick-next pull-right'>${icons.chevron_right_svg}</button>`,
  };

  $(".testimonials__cards").slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "40px",
    arrows: true,
    dots: true,
    prevArrow: buttons.prevArrow,
    nextArrow: buttons.nextArrow,
    responsive: [
      {
        breakpoint: 678,
        settings: {
          slidesToShow: 1,
          centerPadding: "30px",
        },
      },
    ],
  });

  $(".product_upsells-carousel").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    prevArrow: buttons.prevArrow,
    nextArrow: buttons.nextArrow,
  });
  $(".product_upsell-next").click(function () {
    $(".product_upsells-carousel").find(".slick-next").trigger("click");
  });
  $(".product_upsell-prev").click(function () {
    $(".product_upsells-carousel").find(".slick-prev").trigger("click");
  });

  $(".video-reviews__wrapper").slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    variableWidth: true,
    prevArrow: buttons.prevArrow,
    nextArrow: buttons.nextArrow,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 678,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $(".pr-item__product-images.gallery-slider").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    prevArrow: buttons.prevArrow,
    nextArrow: buttons.nextArrow,
  });

  $(".product-showcase__products.pdp-description").slick({
    infinite: true,
    dots: true,
    arrows: true,
    prevArrow: buttons.prevArrow,
    nextArrow: buttons.nextArrow,
    slidesToShow: 2,
    slidesToScroll: 2,
  });

  $(".pr-reviews__reviews--slick").slick({
    infinite: true,
    dots: false,
    arrows: true,
    prevArrow: buttons.prevArrowChevron,
    nextArrow: buttons.nextArrowChevron,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "16px",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 678,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  // Reusable function for thumbnail scrolling and clicking
  function initThumbnailScrolling(container, clickHandler) {
    let isDown = false;
    let startX;
    let scrollLeft;

    // Prevent image dragging
    container.find("img, video").attr("draggable", false);

    // Mouse events for scrolling
    container
      .on("mousedown", function (e) {
        isDown = true;
        container.addClass("grabbing");
        startX = e.pageX;
        scrollLeft = container.scrollLeft();
        e.preventDefault();
      })
      .on("touchstart", function (e) {
        isDown = true;
        container.addClass("grabbing");
        startX = e.originalEvent.touches[0].pageX;
        scrollLeft = container.scrollLeft();
      })
      .on("mouseleave mouseup", function () {
        isDown = false;
        container.removeClass("grabbing");
      })
      .on("touchend touchcancel", function () {
        isDown = false;
        container.removeClass("grabbing");
      })
      .on("mousemove", function (e) {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX;
        const walk = (startX - x) * 1.5;
        container.scrollLeft(scrollLeft + walk);
      })
      .on("touchmove", function (e) {
        if (!isDown) return;
        const x = e.originalEvent.touches[0].pageX;
        const walk = (startX - x) * 1.5;
        container.scrollLeft(scrollLeft + walk);
        e.preventDefault(); // Prevent page scrolling while dragging thumbnails
      });

    // Click handler with isDown check
    if (clickHandler) {
      container.on(
        "click",
        'div:not(.product-image):has(> video, > img, > .product-image[data-type="video"])',
        function () {
          if (isDown) return; // Don't trigger click when dragging
          clickHandler.call(this, isDown);
        },
      );
    }
  }

  // Initialize main thumbnails scrolling
  $(
    '.pdp-main__images .product-images.thumbnails-mobile[data-images="thumbnails"]',
  ).each(function () {
    const container = $(this);

    // Use the reusable function with click handler
    initThumbnailScrolling(container, function () {
      const index = $(this).data("index");
      $(
        '.pdp-main__images.gallery .product-images.slick-initialized[data-images="all"]',
      ).slick("slickGoTo", index);
    });
  });

  $(".draggable-slider").each(function () {
    const slider = $(this);
    let isDown = false;
    let startX;
    let scrollLeft;

    // Prevent image dragging
    slider.find("img").attr("draggable", false);

    // Mouse events for scrolling
    slider
      .on("mousedown", function (e) {
        isDown = true;
        slider.addClass("grabbing");
        startX = e.pageX;
        scrollLeft = slider.scrollLeft();
        e.preventDefault();
      })
      .on("touchstart", function (e) {
        isDown = true;
        slider.addClass("grabbing");
        startX = e.originalEvent.touches[0].pageX;
        scrollLeft = slider.scrollLeft();
      })
      .on("mouseleave mouseup", function () {
        isDown = false;
        slider.removeClass("grabbing");
      })
      .on("touchend touchcancel", function () {
        isDown = false;
        slider.removeClass("grabbing");
      })
      .on("mousemove", function (e) {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX;
        const walk = (startX - x) * 1.5;
        slider.scrollLeft(scrollLeft + walk);
      })
      .on("touchmove", function (e) {
        if (!isDown) return;
        const x = e.originalEvent.touches[0].pageX;
        const walk = (startX - x) * 1.5;
        slider.scrollLeft(scrollLeft + walk);
        e.preventDefault(); // Prevent page scrolling while dragging
      });
  });

  const pdpImages = $('.pdp-main__images .product-images[data-images="all"]');
  const pdpImagesOptions = {
    infinite: true,
    dots: false,
    arrows: true,
    prevArrow: buttons.prevArrowChevron,
    nextArrow: buttons.nextArrowChevron,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const pdpImagesGallery = $(
    '.pdp-main__images.gallery .product-images[data-images="all"]',
  );
  const pdpImagesDesktopOptions = pdpImagesGallery.length
    ? pdpImagesOptions
    : null;

  const TPReviews = $(".tp-reviews__cards");
  const TPRevewsOptions = {
    infinite: true,
    dots: false,
    arrows: true,
    prevArrow: buttons.prevArrow,
    nextArrow: buttons.nextArrow,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const TPRevewsDesktopOptions = $(".tp-reviews__cards.desktop-carousel").length
    ? {
      infinite: true,
      dots: false,
      arrows: true,
      prevArrow: buttons.prevArrow,
      nextArrow: buttons.nextArrow,
      slidesToShow: 2,
      slidesToScroll: 2,
    }
    : null;

  const ProductShowcase = $(
    ".product-showcase__products:not(.pdp-description)",
  );
  const ProductShowcaseOptions = {
    infinite: true,
    dots: true,
    arrows: true,
    prevArrow: buttons.prevArrow,
    nextArrow: buttons.nextArrow,
    slidesToShow: 2,
    slidesToScroll: 2,
  };

  // handleResponsiveCarousel(TPReviews, TPRevewsOptions, 1024, TPRevewsDesktopOptions);
  handleResponsiveCarousel(ProductShowcase, ProductShowcaseOptions, 753);
  handleResponsiveCarousel(
    pdpImages,
    pdpImagesOptions,
    1024,
    pdpImagesDesktopOptions,
  );

  // Video reviews --------------------------------------------------------
  $(".video-reviews__video-button.play, .video-reviews__video").click(
    function () {
      const $videoWrapper = $(this).is(".video-reviews__video")
        ? $(this)
        : $(this).closest(".video-reviews__video");
      const $video = $videoWrapper.find("video");

      if ($video.length) {
        if (!$video.get(0).paused) {
          $video.get(0).pause();
          $videoWrapper
            .removeClass("play")
            .find(".video-reviews__video-button.pause")
            .hide();
          $videoWrapper
            .find(".video-reviews__video-button.play")
            .css("display", "flex");
          return;
        }
        $(".video-reviews__video").each(function () {
          const $otherWrapper = $(this);
          const $otherVideo = $otherWrapper.find("video");
          if ($otherVideo.get(0) !== $video.get(0)) {
            $otherVideo.prop("muted", true).get(0).pause();
            $otherWrapper
              .removeClass("play")
              .find(".video-reviews__video-button.play")
              .css("display", "flex");
            $otherWrapper.find(".video-reviews__video-button.pause").hide();
          }
        });

        $video.prop("muted", false).prop("volume", 0.5).get(0).play();
        $(this).is($videoWrapper)
          ? $videoWrapper.find(".video-reviews__video-button.play").hide()
          : $(this).hide();
        $videoWrapper
          .addClass("play")
          .find(".video-reviews__video-button.pause")
          .css("display", "flex");
      }
    },
  );
  $(".video-reviews__video-button.play").click(function (e) {
    e.stopPropagation();
  });

  // Announcement Timer
  function AnnouncementTimer() {
    const timerWrap = $(".announcement__timer, .announcement__timer-labeled");
    if (!timerWrap.length) return;

    let time;
    const timerDate = timerWrap.data("timer-date");
    if (timerDate) {
      const targetTime = new Date(timerDate + "T00:00:00"); // Local midnight of the given date
      time = Math.floor((targetTime - new Date()) / 1000); // Time difference in seconds
    } else {
      time = parseInt(timerWrap.data("time"), 10);
    }

    if (time <= 0) return timerWrap.hide(); // Ensures valid countdown

    const calculateTime = () => {
      const hours = Math.floor(time / 3600);
      const minutes = Math.floor((time % 3600) / 60);
      const seconds = time % 60;
      return { hours, minutes, seconds };
    };

    const updateSimple = ({ hours, minutes, seconds }) => {
      timerWrap
        .find(".timer")
        .text(
          [hours, minutes, seconds]
            .map((v) => v.toString().padStart(2, "0"))
            .join(":"),
        );
    };
    const updateLabeled = ({ hours, minutes, seconds }) => {
      console.log(hours, minutes, seconds);
      timerWrap.find(".hours").text(hours.toString().padStart(2, "0"));
      timerWrap.find(".minutes").text(minutes.toString().padStart(2, "0"));
      timerWrap.find(".seconds").text(seconds.toString().padStart(2, "0"));
    };

    const update = () => {
      if (time < 0) return timerWrap.hide();
      timerWrap.hasClass("announcement__timer-labeled")
        ? updateLabeled(calculateTime())
        : updateSimple(calculateTime());
      time--;
    };

    update();
    setInterval(update, 1000);
  }

  // Easter Banner Timer
  function EasterBannerTimer(usePDT = false) {
    const timerElement = $(".easter-banner__timer-value");
    if (!timerElement.length) return;

    const endDate = new Date("April 25, 2025 23:59:59").getTime();

    function updateTimer() {
      // If using PDT, adjust time by calculating PDT from UTC
      const now = usePDT
        ? new Date().getTime() +
        new Date().getTimezoneOffset() * 60000 -
        7 * 3600000
        : new Date().getTime();

      const timeLeft = endDate - now;
      if (timeLeft <= 0) return timerElement.parent().hide();

      const days = Math.floor(timeLeft / 86400000);
      const hours = Math.floor((timeLeft % 86400000) / 3600000);
      const minutes = Math.floor((timeLeft % 3600000) / 60000);
      const seconds = Math.floor((timeLeft % 60000) / 1000);

      timerElement.text(
        days > 0
          ? `${days} Days ${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`
          : `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`,
      );
    }

    updateTimer();
    setInterval(updateTimer, 1000);
  }

  // Initialize section code
  if ($(".announcement__timer, .announcement__timer-labeled").length > 0) {
    AnnouncementTimer();
    $(".announcement__text a").on("click", function (e) {
      e.preventDefault();
      var text = $(this).text().trim();
      copyToClipboard(text);
      log.collapse(text, "Copied to Clipboard");
    });
  }

  // Initialize Easter Banner Timer
  if ($(".easter-banner__timer-value").length > 0) {
    // Pass true to use PDT timezone, false or nothing to use local time
    EasterBannerTimer(true);
  }

  $(".ScrollToProduct").on("click", function (e) {
    e.preventDefault();
    const offsetTop = $("#product-main").offset().top - 160;
    $("html, body").animate(
      {
        scrollTop: offsetTop,
      },
      600,
    );
  });

  $(".AddToCart").on("click", function (e) {
    e.preventDefault();
    const variantId = $(this).data("id");
    $.post(
      "/cart/add.js",
      {
        items: [{ id: variantId, quantity: 1 }],
      },
      function (response) {
        log.collapse(response, "Added to Cart", "success");
        theme.ajaxCart.update();
      },
    ).fail(function (response) {
      log.collapse(response, "Add to Cart Failed", "error");
    });
  });

  $(".accordion > .accordion-item").children(".accordion-panel").slideUp();
  $(".accordion > .accordion-item.is-active")
    .children(".accordion-panel")
    .slideDown();
  $(".accordion > .accordion-item").click(function () {
    $(this)
      .siblings(".accordion-item")
      .removeClass("is-active")
      .children(".accordion-panel")
      .slideUp();
    if ($(this).hasClass("is-active")) {
      $(this)
        .removeClass("is-active")
        .children(".accordion-panel")
        .slideUp("ease-out");
    } else {
      $(this)
        .addClass("is-active")
        .children(".accordion-panel")
        .slideDown("ease-out");
    }
  });

  // PDP Popup Upsell
  if ($(".popup-upsell__button-atc").length > 0) {
    log.collapse(true, "Popup Upsell Exists");
    function addToCartPopup($popupBtn) {
      $(".popup-upsell:not(body)").removeClass("active");

      const $button = $popupBtn || $(".popup-upsell__button-atc");
      const upsellId = $button.data("id");

      // Get mainId from URL parameter or data attribute
      const urlParams = new URLSearchParams(window.location.search);
      const mainId = urlParams.get("variant") || $button.data("main-id");
      // Get selling plan from URL parameter
      const mainSellingId = urlParams.get("selling_plan") || undefined;

      const items = [{ id: mainId, quantity: 1, selling_plan: mainSellingId }];
      if ($popupBtn) items.push({ id: upsellId, quantity: 1 });

      log.collapse(items, "Add to Cart");

      $.post(
        "/cart/add.js",
        {
          items,
        },
        function (response) {
          theme.ajaxCart.update();
        },
      ).fail(function (response) {
        log.collapse(response, "Add to Cart Failed", "error");
      });
    }

    async function checkIfUpsellInCart() {
      const cart = await window._pf_getCart();
      const cartItems = cart.items;
      const upsellId = $(".popup-upsell__button-atc").data("id");
      const upsellInCart = cartItems.some((item) => item.id === upsellId);
      log.collapse({ upsellInCart, cartItems, upsellId }, "Upsell in Cart");
      return upsellInCart;
    }

    $(".product-single__add-to-cart .btn--add-to-cart").on(
      "click",
      async function (e) {
        e.preventDefault();
        const upsellInCart = await checkIfUpsellInCart();
        if (!upsellInCart) {
          $(".popup-upsell:not(body)").addClass("active");
          $(".accordion > .accordion-item")
            .children(".accordion-panel")
            .slideUp();
          $(".accordion > .accordion-item.is-active")
            .children(".accordion-panel")
            .slideDown();
        } else {
          addToCartPopup();
        }
      },
    );

    $(".popup-upsell__button-atc").on("click", function (e) {
      e.preventDefault();
      addToCartPopup($(this));
    });

    $(".popup-upsell__button-decline").on("click", function (e) {
      e.preventDefault();
      addToCartPopup();
    });
  }

  // ------------------------ Product Options --Custom Dropdown -----------------------------------
  // -- USED IN: Cart Drawer items, Cart Drawer upsells, Cart Drawer gift popup, PDP Main, PDP Bundle --
  (function ($) {
    let $open = null,
      $menu = null,
      $btn = null;

    function place() {
      if (!$btn || !$menu) return;
      const r = $btn[0].getBoundingClientRect();
      const vw = window.innerWidth,
        vh = window.innerHeight,
        gap = 6;

      // measure natural height (temporarily show to measure)
      const prevDisp = $menu.css("display");
      $menu.css({ visibility: "hidden", display: "block", maxHeight: "" });
      const natH = $menu.outerHeight();
      $menu.css({ display: prevDisp, visibility: "" });

      const spaceBelow = vh - r.bottom - gap;
      const spaceAbove = r.top - gap;
      const openBelow =
        spaceBelow >= Math.min(natH, 320) || spaceBelow >= spaceAbove;
      const maxH = Math.min(320, openBelow ? spaceBelow : spaceAbove);

      const left = Math.min(r.left, vw - r.width - 4);
      const top = openBelow ? r.bottom + gap : Math.max(4, r.top - maxH - gap);

      $menu
        .addClass("ms-fixed")
        .css({
          left: Math.round(left),
          top: Math.round(top),
          width: Math.round(r.width),
          maxHeight: Math.round(maxH),
        })
        .show();
    }

    function open($select) {
      if ($open && $open.is($select)) {
        close();
        return;
      }
      close();

      $open = $select.addClass("open");
      $btn = $select.find(".main-select__label");
      $menu = $select.find(".main-select__menu");

      place();
      $(window).on("resize.ms scroll.ms", place);
    }

    function close() {
      if (!$open) return;
      $open.removeClass("open");
      if ($menu) $menu.removeClass("ms-fixed").attr("style", "").hide();
      $open = $menu = $btn = null;
      $(window).off("resize.ms scroll.ms");
    }

    // Toggle open
    $(document).on("click", ".main-select__label", function (e) {
      e.stopPropagation();
      open($(this).closest(".main-select"));
    });

    // Select item (scoped to the currently open main-select)
    $(document).on("click", ".main-select__item", function () {
      const $this = $(this);
      const $select = $open || $this.closest(".main-select"); // the active select

      // Clear old selection inside this dropdown only
      $select.find(".main-select__item").removeAttr("data-selected");
      $this.attr("data-selected", "true");

      // Update label text
      const selectedText = $this.find(".item-label").text().trim();
      $select.find(".main-select__label p").text(selectedText);

      // Optional: support for color swatches (like in your original logic)
      if ($this.hasClass("color")) {
        $select
          .find(".main-select__label .main-color-swatch div")
          .attr("style", $this.find(".main-color-swatch div").attr("style"));
      }

      close(); // close dropdown after choosing
    });

    // Click outside closes
    $(document).on("click", close);
  })(jQuery);

  // ----------------------- Handle Modals -----------------------
  function handleModal(modalSelector, triggerSelector) {
    const $modal = $(modalSelector);
    let lastScrollY = null;

    // Open modal
    $(triggerSelector).on("click", function () {
      lastScrollY = window.scrollY;
      $modal.addClass("active").attr("aria-hidden", "false").fadeIn();
      $("body").addClass("no-scroll");
      $("#main").css({
        "z-index": "21",
        position: "relative",
      });
    });

    // Close modal
    $(".modal-close, .modal-overlay").on("click", function () {
      $modal.removeClass("active").attr("aria-hidden", "true").fadeOut();
      $("body").removeClass("no-scroll");
      $("#main").css({
        "z-index": "unset",
        position: "unset",
      });
      if (lastScrollY !== null)
        setTimeout(
          () => window.scrollTo({ top: lastScrollY, behavior: "instant" }),
          10,
        );
    });
  }
  // Initialize modals
  handleModal(
    "#size-guide-modal",
    ".pdp-main__size-guide-btn, .pdp-main-bundle__size-guide-btn",
  );
  handleModal(
    "#pdp-main-popup",
    ".pdp-main-bundle__product-learn-more, .pdp-main-bundle__gift",
  );

  // ======================= Image Modal Gallery =========================
  function initImageModal() {
    const $modal = $(".image-modal");
    const $zoomBtn = $(".product-image__zoom");
    const $mainGallery = $(
      '.pdp-main__images.gallery .product-images[data-images="all"]',
    );
    const $mainThumbnails = $(
      '.pdp-main__images .product-images.thumbnails-mobile[data-images="thumbnails"]',
    );

    if (!$modal.length || !$zoomBtn.length) return;

    let modalSlickInitialized = false;
    let currentSlideIndex = 0;

    // Clone gallery content to modal
    function cloneGalleryToModal() {
      const $modalMain = $modal.find(".image-modal__main-slider");
      const $modalThumbnails = $modal.find(".image-modal__thumbnails");

      // Clear existing content
      $modalMain.empty();
      $modalThumbnails.empty();

      // Clone main gallery slides in order (exclude cloned slides)
      $mainGallery
        .find(".slick-slide:not(.slick-cloned)")
        .each(function (slideIndex) {
          const $slide = $(this).clone();
          $slide
            .removeClass("slick-slide slick-cloned")
            .addClass("modal-slide");
          $modalMain.append($slide);
        });

      // Clone thumbnails in the same order
      $mainThumbnails.find("div[data-index]").each(function () {
        const $thumb = $(this).clone();
        const index = $thumb.data("index");
        $thumb.removeClass().addClass("thumbnail-item");
        $thumb.attr("data-modal-index", index);
        $modalThumbnails.append($thumb);
      });
    }

    // Initialize modal Slick carousel
    function initModalSlick() {
      if (modalSlickInitialized) return;

      const $modalSlider = $modal.find(".image-modal__main-slider");

      $modalSlider.slick({
        infinite: true,
        dots: false,
        arrows: true,
        prevArrow: buttons.prevArrowChevron,
        nextArrow: buttons.nextArrowChevron,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: currentSlideIndex,
        adaptiveHeight: true,
      });

      modalSlickInitialized = true;

      // Sync thumbnail selection with main slider
      $modalSlider.on("afterChange", function (event, slick, currentSlide) {
        currentSlideIndex = currentSlide;
        updateThumbnailSelection(currentSlide);
      });
    }

    // Update thumbnail selection
    function updateThumbnailSelection(activeIndex) {
      $modal.find(".thumbnail-item").removeClass("active");
      // Since slides and thumbnails are in the same order, use the slide index directly
      $modal.find(".thumbnail-item").eq(activeIndex).addClass("active");
    }

    // Handle modal thumbnails scrolling using the reusable function
    function initModalThumbnailScrolling() {
      const $modalThumbnails = $modal.find(".image-modal__thumbnails");
      initThumbnailScrolling($modalThumbnails, function () {
        const thumbnailIndex = $(this).index();
        $modal
          .find(".image-modal__main-slider")
          .slick("slickGoTo", thumbnailIndex);
      });
    }

    // Open modal
    function openModal(slideIndex = 0) {
      currentSlideIndex = slideIndex;
      cloneGalleryToModal();
      $modal.addClass("active").attr("aria-hidden", "false");
      $("body").addClass("no-scroll");

      // Initialize Slick after a short delay to ensure DOM is ready
      setTimeout(() => {
        initModalSlick();
        updateThumbnailSelection(currentSlideIndex);
      }, 100);
    }

    // Close modal
    function closeModal() {
      // Prevent multiple close calls
      if ($modal.hasClass("closing")) return;

      $modal.addClass("closing");
      $modal.css("animation", "zoomOut 0.3s ease-in");

      setTimeout(() => {
        $modal.removeClass("active closing").attr("aria-hidden", "true");
        $modal.css("animation", "");
        $("body").removeClass("no-scroll");

        // Destroy Slick to prevent memory leaks
        if (modalSlickInitialized) {
          $modal.find(".image-modal__main-slider").slick("unslick");
          modalSlickInitialized = false;
        }
      }, 300);
    }

    // Event handlers
    $zoomBtn.on("click", function (e) {
      e.preventDefault();
      const currentIndex = $mainGallery.slick("slickCurrentSlide");
      openModal(currentIndex);
    });

    // Close button click handler - use document delegation
    $(document)
      .on("click", ".image-modal__close", (e) => {
        e.preventDefault();
        e.stopPropagation();
        if ($modal.hasClass("active")) closeModal();
      })
      .on("click", ".image-modal__overlay", function (e) {
        if (e.target === this) closeModal();
      });

    // Keyboard navigation
    $(document).on("keydown", function (e) {
      if ($modal.hasClass("active")) {
        if (e.key === "Escape") {
          closeModal();
        } else if (e.key === "ArrowLeft") {
          $modal.find(".image-modal__main-slider").slick("slickPrev");
        } else if (e.key === "ArrowRight") {
          $modal.find(".image-modal__main-slider").slick("slickNext");
        }
      }
    });

    // Initialize thumbnail scrolling
    initModalThumbnailScrolling();
  }

  // Initialize image modal
  initImageModal();

  // PDP Size Chart & Calculator: move/clone to variant picker, hide original
  function moveSizeChartAndCalcToVariantPicker() {
    const selectors = {
      chart: ".ks-chart-container",
      calc: ".ks-calculator-container",
      origin: '.product-info__block-item[data-block-id="buy_buttons"]',
      destination:
        ".variant-picker__option[data-size-option] > .variant-picker__option-info, .variant-picker__option:has(button.select) > .variant-picker__option-info",
      modalLink: ".sizing-chart-modal-link",
    };

    let isProcessing = false;

    function moveChart() {
      if (isProcessing) return;
      isProcessing = true;

      const chartOrig = document.querySelector(
        `${selectors.origin} ${selectors.chart}`,
      );
      const calcOrig = document.querySelector(
        `${selectors.origin} ${selectors.calc}`,
      );
      const destParents = document.querySelectorAll(selectors.destination);

      if (!chartOrig || !destParents.length) {
        isProcessing = false;
        return;
      }

      // Hide original, remove existing clones
      chartOrig.classList.add("hidden");
      destParents.forEach((parent) => {
        parent.querySelectorAll(selectors.chart).forEach((el) => el.remove());
        parent.querySelectorAll(selectors.calc).forEach((el) => el.remove());
      });

      // Create and insert clones
      destParents.forEach((parent) => {
        const chartClone = chartOrig.cloneNode(true);
        chartClone.classList.remove("hidden");

        // Add click handlers
        const modalLink = chartClone.querySelector(selectors.modalLink);
        if (modalLink) {
          modalLink.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            chartOrig.querySelector(selectors.modalLink)?.click();
          });
        }

        parent.appendChild(chartClone);
        if (calcOrig) parent.appendChild(calcOrig.cloneNode(true));
      });

      isProcessing = false;
    }

    // Watch for chart appearance
    const observer = new MutationObserver((mutations) => {
      mutations.forEach(({ addedNodes }) => {
        addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const chart = node.matches?.(selectors.chart)
              ? node
              : node.querySelector?.(selectors.chart);
            if (chart) {
              log.collapse("Chart detected", "Size Chart", "info");
              setTimeout(moveChart, 50);
            }
          }
        });
      });
    });

    // Setup observers
    const buyButtonsArea = document.querySelector(selectors.origin);
    if (buyButtonsArea)
      observer.observe(buyButtonsArea, { childList: true, subtree: true });

    // Initial check and variant change handler
    moveChart();
    $(document).on(
      "click",
      ".variant-picker__option-values .color-swatch, .popover-listbox__option",
      () => {
        setTimeout(moveChart, 30);
      },
    );
  }
  moveSizeChartAndCalcToVariantPicker();

  // KiwiSizing injects into the variant-picker size option. That block is replaced on every
  // variant change, detaching KiwiSizing's nodes. We hold references to the actual nodes so
  // we can re-append the same elements (with their event listeners intact) after each rerender.
  (function preserveKiwiSizeChart() {
    const DEST = '.variant-picker__option[data-size-option] > .variant-picker__option-info';
    const CHART = '.ks-chart-container';
    const CALC = '.ks-calculator-container';

    let chartNode = null;
    let calcNode = null;

    function captureNodes() {
      const dest = document.querySelector(DEST);
      if (!dest) return;
      chartNode = chartNode || dest.querySelector(CHART);
      calcNode = calcNode || dest.querySelector(CALC);
      if (chartNode) observer.disconnect();
    }

    function restoreNodes() {
      if (!chartNode) return;
      const dest = document.querySelector(DEST);
      if (!dest) return;
      if (!dest.contains(chartNode)) dest.appendChild(chartNode);
      if (calcNode && !dest.contains(calcNode)) dest.appendChild(calcNode);
    }

    const observer = new MutationObserver(captureNodes);
    observer.observe(document.body, { childList: true, subtree: true });
    captureNodes();

    document.addEventListener('variant:change', () => setTimeout(restoreNodes, 0));
  }());

  const productGalleryImagesState = {
    originalSrcsets: null,
    originalAlts: null,
  };

  const pgLog = (data, title, status = "info") => log.collapse(data, `PG Images · ${title}`, status);

  const pgHandleize = (str) =>
    String(str || "")
      .toLowerCase()
      .replace(/ /g, "-")
      .replace(/\./g, "-")
      .replace(/[^\w-]+/g, "")
      .replace(/-+/g, "-");

  function getSelectedColorHandle(variant) {
    const $checked = $(".variant-picker__option:has(.thumbnail-swatch) input[data-option-handle]:checked");
    if ($checked.length) return $checked.data("optionHandle");

    const $swatch = $(".thumbnail-swatch.is-selected[data-option-handle]").first();
    if ($swatch.length) return $swatch.data("optionHandle");

    if (variant?.option1) return pgHandleize(variant.option1);

    return null;
  }

  let productGalleryUpdateTimer;

  function scheduleUpdateProductGalleryImages(source, variant) {
    clearTimeout(productGalleryUpdateTimer);
    productGalleryUpdateTimer = setTimeout(function () {
      const color = getSelectedColorHandle(variant);
      if (!color) {
        pgLog({ source, variant }, "abort · no color handle", "warning");
        return;
      }
      updateProductGalleryImages(color);
    }, 30);
  }

  /** Mirrors Product.updateImages() in pdp-main.js */
  function updateProductGalleryImages(color) {
    const $imageContainer = $("product-gallery").first().find("media-carousel").first();
    if (!$imageContainer.length) return false;

    const $firstImage = $imageContainer.find("img").first();
    const colorSrcset = $firstImage.attr(`data-${color}-srcset`);

    if (!colorSrcset) {
      pgLog({ color }, "abort · no data-*-srcset on main", "error");
      return false;
    }

    if (!productGalleryImagesState.originalSrcsets) {
      productGalleryImagesState.originalSrcsets = new Map();
      productGalleryImagesState.originalAlts = new Map();
      $imageContainer.find("img").each((_, img) => {
        const $img = $(img);
        const variantKey = $img.attr("data-variant");
        if (variantKey) {
          productGalleryImagesState.originalSrcsets.set(variantKey, $img.attr("srcset"));
          productGalleryImagesState.originalAlts.set(variantKey, $img.attr("alt"));
        }
      });
    }

    $imageContainer.find("img").each((_, img) => {
      const $img = $(img);
      const variantKey = $img.attr("data-variant");
      if (variantKey && productGalleryImagesState.originalSrcsets.has(variantKey)) {
        $img.attr({
          srcset: productGalleryImagesState.originalSrcsets.get(variantKey),
          alt: productGalleryImagesState.originalAlts.get(variantKey),
        });
      }
    });

    const $variantImage = $imageContainer.find(`img[data-variant="${color}"]`);

    if ($variantImage.length) {
      const firstImageState = {
        srcset: $firstImage.attr("srcset"),
        alt: $firstImage.attr("alt"),
      };
      $variantImage.attr({
        srcset: firstImageState.srcset,
        alt: firstImageState.alt,
      });
      $firstImage.attr({
        srcset: colorSrcset,
        alt: `${$firstImage.attr("data-alt")} ${color.charAt(0).toUpperCase() + color.slice(1)}`,
      });
      return true;
    }

    pgLog({ color }, "abort · no img[data-variant]", "error");
    return false;
  }

  function changeMainGallery() {
    // console.group("🔄 changeMainGallery");

    var currentId = $(".shopify-product-form").find('input[name="id"]').val();
    // console.log("Variant ID:", currentId);

    if (!currentId) {
      // console.warn("❌ No variant ID found");
      // console.groupEnd();
      return;
    }

    var selector =
      'template.product_gallery-array[data-id="' + currentId + '"]';
    // console.log("Looking for template:", selector);

    var $template = $(selector);
    if (!$template.length) {
      // console.warn("❌ Template not found");
      // console.groupEnd();
      return;
    }

    var templateEl = $template.get(0);
    // console.log("✅ Template found:", templateEl);

    // ✅ IMPORTANT FIX: do NOT use $(templateEl.content).html()
    // Use innerHTML (works for <template>) OR build HTML from fragment children
    var templateHtml = templateEl.innerHTML;

    // Extra debug to prove it
    // console.log(
    //   "templateEl.innerHTML length:",
    //   templateHtml ? templateHtml.length : 0,
    // );
    // console.log(
    //   "First 200 chars:",
    //   templateHtml ? templateHtml.slice(0, 200) : "(empty)",
    // );

    if (!templateHtml || !templateHtml.trim()) {
      // console.error("❌ Template HTML is empty (innerHTML)");
      // console.groupEnd();
      return;
    }

    // Get new media-carousel from template
    var $newCarousel = $(templateHtml).filter("media-carousel").first();
    if (!$newCarousel.length) {
      $newCarousel = $(templateHtml).find("media-carousel").first();
    }

    if (!$newCarousel.length) {
      // console.error("❌ media-carousel not found inside template");
      // console.groupEnd();
      return;
    }

    // console.log("✅ New carousel found:", $newCarousel.get(0));

    var $gallery = $("product-gallery").first();
    var $currentCarousel = $gallery.find("media-carousel").first();

    // console.log("Current carousel:", $currentCarousel.get(0));

    if (!$currentCarousel.length) {
      // console.error("❌ Current media-carousel not found");
      // console.groupEnd();
      return;
    }

    $currentCarousel.replaceWith($newCarousel);
    productGalleryImagesState.originalSrcsets = null;
    productGalleryImagesState.originalAlts = null;

    // console.groupEnd();
  }

  const hasGalleryTemplates = $("template.product_gallery-array").length > 0;
  pgLog(
    {
      flow: hasGalleryTemplates ? "changeMainGallery (templates)" : "updateProductGalleryImages (srcset)",
      templateCount: $("template.product_gallery-array").length,
      productGalleryCount: $("product-gallery").length,
    },
    "init",
    "info",
  );

  if (hasGalleryTemplates) {
    $(document).on("change", ".variant-picker__option", function () {
      setTimeout(function () {
        changeMainGallery();
      }, 30);
    });

    $(document).on("click", "[data-gender-selector]", function () {
      setTimeout(function () {
        changeMainGallery();
      }, 30);
    });
  } else {
    document.addEventListener("variant:change", function (event) {
      scheduleUpdateProductGalleryImages("variant:change", event.detail?.variant);
    });
  }
});
